module.exports = __webpack_public_path__ + "img/room01_bookA.ce06a4ac.png";